import type { PublicCatalogueStatus } from "../../types/catalogue.types";

export type CatalogueUnlockIdentity = "email" | "phone";
export type CatalogueUnlockPrimary = "password" | "otp";
export type CatalogueUnlockOtpChannel = "email" | "sms";

export type CatalogueUnlockProfile = {
  identity: CatalogueUnlockIdentity;
  primary: CatalogueUnlockPrimary;
  otpChannel: CatalogueUnlockOtpChannel | null;
};

function fallbackIdentity(status: PublicCatalogueStatus): CatalogueUnlockIdentity {
  const password = Boolean(status.passwordUnlockAvailable || status.requirePassword);
  const email = Boolean(status.emailOtpAvailable);
  const sms = Boolean(status.otpAvailable);
  if (email && password) return "email";
  if (sms) return "phone";
  if (email) return "email";
  return "phone";
}

function smsAvailable(status: PublicCatalogueStatus): boolean {
  return Boolean(
    status.otpAvailable ||
      (status.otpRequired && status.otpAvailable !== false && !status.emailOtpAvailable)
  );
}

/** One guest-facing unlock form. No Password / Email-code tabs. */
export function catalogueUnlockProfile(
  status?: PublicCatalogueStatus | null
): CatalogueUnlockProfile | null {
  if (!status || status.linkValid === false) return null;
  const identity: CatalogueUnlockIdentity =
    status.unlockIdentity === "email" || status.unlockIdentity === "phone"
      ? status.unlockIdentity
      : fallbackIdentity(status);
  const password = Boolean(status.passwordUnlockAvailable || status.requirePassword);
  if (identity === "email") {
    return {
      identity: "email",
      primary: password ? "password" : "otp",
      otpChannel: status.emailOtpAvailable ? "email" : null,
    };
  }
  const sms = smsAvailable(status);
  if (password) {
    return { identity: "phone", primary: "password", otpChannel: sms ? "sms" : null };
  }
  if (sms) {
    return { identity: "phone", primary: "otp", otpChannel: "sms" };
  }
  return { identity: "phone", primary: "password", otpChannel: sms ? "sms" : null };
}
